import React from 'react';
import { C } from './constants.jsx';

const TBtn = ({ onClick, label, disabled, active }) => (
  <button
    onClick={onClick}
    disabled={disabled}
    style={{
      padding: '5px 9px', fontSize: 12,
      border: `1px solid ${active ? C.accent : C.border}`,
      borderRadius: 6,
      background: active ? C.accentLt : 'transparent',
      color: disabled ? C.muted : active ? C.accent : C.sub,
      cursor: disabled ? 'not-allowed' : 'pointer',
      fontFamily: 'inherit', opacity: disabled ? 0.5 : 1, transition: 'all .1s',
    }}
    onMouseEnter={(e) => { if (!disabled && !active) { e.currentTarget.style.background = C.bg; e.currentTarget.style.color = C.text; } }}
    onMouseLeave={(e) => { if (!disabled && !active) { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = C.sub; } }}
  >
    {label}
  </button>
);

export default function Toolbar({
  screenName, onNameChange,
  zoom, onZoom, onZoomReset, onZoomFit,
  canUndo, onUndo,
  snapOn, onToggleSnap,
  previewMode, onTogglePreview,
  onExport,
}) {
  return (
    <div style={{
      height: 50, background: C.surface, borderBottom: `1px solid ${C.border}`,
      display: 'flex', alignItems: 'center', padding: '0 13px', gap: 5, flexShrink: 0,
    }}>
      <input
        value={screenName}
        onChange={(e) => onNameChange(e.target.value)}
        style={{
          fontSize: 14, fontWeight: 600, border: 'none', outline: 'none',
          background: 'transparent', color: C.text, minWidth: 120, fontFamily: 'inherit',
        }}
      />

      <div style={{ width: 1, height: 20, background: C.border, margin: '0 2px', flexShrink: 0 }} />

      <TBtn onClick={() => onZoom(-0.1)} label="−" />
      <span style={{ fontSize: 12, color: C.sub, minWidth: 36, textAlign: 'center' }}>
        {Math.round(zoom * 100)}%
      </span>
      <TBtn onClick={() => onZoom(0.1)} label="+" />
      <TBtn onClick={onZoomReset} label="1:1" />
      <TBtn onClick={onZoomFit} label="Fit" />

      <div style={{ width: 1, height: 20, background: C.border, margin: '0 2px', flexShrink: 0 }} />

      <TBtn onClick={onUndo} label="↩ Undo" disabled={!canUndo} />
      <TBtn onClick={onToggleSnap} label={snapOn ? '⊞ Snap' : '⊟ Snap'} active={snapOn} />
      <TBtn onClick={onTogglePreview} label={previewMode ? '✏ Edit' : '👁 Preview'} active={previewMode} />

      <button
        onClick={onExport}
        style={{
          marginLeft: 'auto', padding: '6px 15px', fontSize: 12, fontWeight: 600,
          borderRadius: 6, background: C.accent, color: '#fff', border: 'none',
          cursor: 'pointer', fontFamily: 'inherit',
        }}
      >
        ⬇ Export
      </button>
    </div>
  );
}
